import axios from './axiosHelper';
/**
 * Archivo que contiene las llamadas a los webservices relacionados al administrador de VSC
 *
 * @package    QualtiaApp
 * @author     Ismael Najera  <ismael.najera@qualtia.com>
 * @version    1.0(0.0.1)
 * @date      01/01/2024
 */

//#region Exportación Principal
export const vscService = {
  // Usuarios y Perfiles
  getPerfiles,
  getUsuarios,
  getUserByMail,
  postInsertaUsuario,
  putEditaUsuario,
  delEliminaUsuario,  
  // Sociedades y Cadenas
  getSociedades,
  getCadenas,  
  // Motivos
  getMotivosVSC,
  getMotivoById,
  postInsertaMotivo,
  putEditaMotivo,
  delEliminaMotivo,  
  // Segmentos
  getSegmentos,
  getSegmentoById,
  postInsertaSegmento,
  putEditaSegmento,
  delEliminaSegmento,
  // Clientes
  getClientes,
  // Porcentajes
  getPorcentajes,
  getPorcentajeBySociedad,
  postInsertaPorcentaje,
  putEditaPorcentaje,
  delEliminaPorcentaje,  
  // Configuraciones
  postInsertaConfiguracion,
  putActualizarConfiguracion,
  deleteEliminarConfiguracion,
  getConfiguraciones,
  getConfiguracionPorId,  
  // Reglas de Descuento
  getReglasDescuento,
  postInsertaReglaDescuento,
  putEditaReglaDescuento,
  delEliminaReglaDescuento,
  // Ventas Autorizadas
  getVentasAutorizadasPorMes,
  postMovimientosVSC
};
//#endregion

//#region Usuarios y Perfiles
function getPerfiles() {
  return axios.getData(`/MetodosVSC/ObtenerPerfiles`, true);
}

function getUsuarios() {
  return axios.getData(`/MetodosVSC/ObtenerUsuarios`, true);
}

function getUserByMail(email) {
  return axios.getData(`/MetodosVSC/ObtenerUsuarioByEmail/` + email, true);
}

function postInsertaUsuario(json) {
  return axios.postData(`/MetodosVSC/InsertarUsuario`, json, true);
}

function putEditaUsuario(json) {
  return axios.putData(`/MetodosVSC/ActualizarUsuario`, json, true);
}

function delEliminaUsuario(id) {
  return axios.delete(`/MetodosVSC/EliminarUsuario/` + id, true);
}
//#endregion

//#region Sociedades y Cadenas
function getSociedades() {
  return axios.getData(`/MetodosVSC/ObtenerSociedades`, true);
}

function getCadenas() {
  return axios.getData(`/MetodosVSC/ObtenerCadenas`, true);
}
//#endregion

//#region Cientes
function getClientes(busqueda) {
  return axios.getData(`/MetodosVSC/ObtenerClientes/` + busqueda, true);
}
//#endregion

//#region Motivos
function getMotivosVSC() {
  return axios.getData(`/MetodosVSC/ObtenerMotivos`, true);
}

function getMotivoById(id) {
  return axios.getData(`/MetodosVSC/ObtenerMotivoById/` + id, true);
}

function postInsertaMotivo(json) {
  return axios.postData(`/MetodosVSC/InsertarMotivo`, json, true);
}

function putEditaMotivo(json) {
  return axios.putData(`/MetodosVSC/ActualizarMotivo`, json, true);
}

function delEliminaMotivo(id) {
  return axios.delete(`/MetodosVSC/EliminarMotivo/` + id, true);
}
//#endregion

//#region Segmentos
function getSegmentos() {
  return axios.getData(`/MetodosVSC/ObtenerSegmentos`, true);
}

function getSegmentoById(id) {
  return axios.getData(`/MetodosVSC/ObtenerSegmentoById/` + id, true);
}

function postInsertaSegmento(json) {
  return axios.postData(`/MetodosVSC/InsertarSegmento`, json, true);
}

function putEditaSegmento(json) {
  return axios.putData(`/MetodosVSC/ActualizarSegmento`, json, true);
}

function delEliminaSegmento(clave) {
  return axios.delete(`/MetodosVSC/EliminarSegmento/` + clave, true);
}
//#endregion

//#region Porcentajes
function getPorcentajes() {
  return axios.getData(`/MetodosVSC/ObtenerPorcentajes`, true);
}

function getPorcentajeBySociedad(sociedad) {
  return axios.getData(`/MetodosVSC/ObtenerPorcentajeBySociedad/` + sociedad, true);
}

function postInsertaPorcentaje(json) {
  return axios.postData(`/MetodosVSC/InsertarPorcentaje`, json, true);
}

function putEditaPorcentaje(json) {
  return axios.putData(`/MetodosVSC/ActualizarPorcentaje`, json, true);
}

function delEliminaPorcentaje(id) {
  return axios.delete(`/MetodosVSC/EliminarPorcentaje/` + id, true);
}
//#endregion

//#region Configuraciones
function postInsertaConfiguracion(data) {
  return axios.postData(`/MetodosVSC/InsertarConfiguracion`, data);
}

function putActualizarConfiguracion(data) {
  return axios.putData(`/MetodosVSC/ActualizarConfiguracion`, data);
}

function deleteEliminarConfiguracion(data) {
  return axios.putData(`/MetodosVSC/EliminarConfiguracion`, data);
}

function getConfiguraciones() {
  return axios.getData(`/MetodosVSC/ObtenerConfiguraciones`, true);
}

function getConfiguracionPorId(id) {
  return axios.getData(`/MetodosVSC/ObtenerConfiguracionPorId/${id}`, true);
}
//#endregion

//#region Ventas autorizadas
function getVentasAutorizadasPorMes(mes, anio, tipo) {
  const queryParams = new URLSearchParams();
  queryParams.append('mes', mes);
  const yearToUse = anio || new Date().getFullYear();
  queryParams.append('anio', yearToUse);
  queryParams.append('tipo', tipo);
  return axios.getData(`/MetodosVSC/ObtenerVentasAutorizadas?${queryParams.toString()}`, true);
}
function postMovimientosVSC(json) {
  return axios.postData(`/MetodosVSC/ObtenerMovimientosVSC`, json, true);
}
//#endregion


//#region Reglas de Descuento
function getReglasDescuento() {
  return axios.getData(`/MetodosVSC/ObtenerReglas`, true);
}

function postInsertaReglaDescuento(json) {
  return axios.postData(`/MetodosVSC/InsertarRegla`, json, true);
}

function putEditaReglaDescuento(json) {
  return axios.putData(`/MetodosVSC/ActualizarRegla`, json, true);
}

function delEliminaReglaDescuento(id) {
  return axios.delete(`/MetodosVSC/EliminaRegla/${id}`, true);
}
//#endregion